import { render, staticRenderFns } from "./MailAccountsList.vue?vue&type=template&id=64ca215b&scoped=true&"
import script from "./MailAccountsList.vue?vue&type=script&lang=js&"
export * from "./MailAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./MailAccountsList.vue?vue&type=style&index=0&id=64ca215b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca215b",
  null
  
)

export default component.exports